// lib/sanity.js
import { createClient } from '@sanity/client'

export const sanity = createClient({
  projectId: 'inku71hf',      // ← remplace par le tien
  dataset: 'production',
  apiVersion: '2025-05-10',
  useCdn: true,
})